export default __webpack_public_path__ + "static/media/imgSubCapa.2a21d8d5.webp";